// extracted by mini-css-extract-plugin
module.exports = {"notification-banner":"NotificationBanner_notification-banner__ADasp","close":"NotificationBanner_close__ayyNh"};